"use strict";

(function () {
  'use strict';

  angular.module('app.constants', ['vendor.constants']);
})();